'use strict';

angular.module('directives.empStaging')

.controller('empStagingMatchingRehireController', ['$scope', '$modal', 'employeeSyncService', 'employeeService', function ($scope, $modal, employeeSyncService, employeeService) {

    // Get Business Units
    employeeSyncService
             .getBusinessUnitsByMatching($scope.model)
             .then(function (buToConfContainer) {
                 $scope.buToConfirmContainer = buToConfContainer;
             });

    // Show Confirm Matching Modal
    $scope.showConfirmMatchingModal = function ($event) {
        $event.stopPropagation();
        if ($scope.readOnly) return false;

        var modalScope = $scope.$new(true);

        modalScope.model = $scope.model;
        modalScope.modalCtxt = {};
        modalScope.ctrlCtxt = $scope.ctrlCtxt;
        modalScope.buToConfirmContainer = $scope.buToConfirmContainer;

        // Get Ignored Matchings When Confirm Matching
        employeeSyncService
              .getIgnoredMatchingsWhenConfirmMatching($scope.model)
              .then(function (ignoredMatchings) {
                  modalScope.ignoredMatchings = ignoredMatchings;
              });

        // Get proposed employee Active Directory username
        employeeService
            .checkWindowsAccount(modalScope.model.FirstName, modalScope.model.LastName)
            .then(function (proposedAccount) {
                modalScope.modalCtxt.proposedAccount = proposedAccount;

                if (proposedAccount.IsFirstRule) {
                    modalScope.selectProposedUsername();
                    return;
                }

                modalScope.selectCustomUsername();
            });

        var confirmMatchingModal = $modal({
            scope: modalScope,
            template: require('./empStagingDirective-matching-DetectEmployeeRehire-confirmModal.tpl.html'),
            placement: 'center'
        });

        modalScope.hideModal = function () {
            return confirmMatchingModal.$promise.then(confirmMatchingModal.hide);
        }

        modalScope.okModal = function () {
            modalScope.hideModal();
        }

        // Select Proposed Employee Active Directory username Choice
        modalScope.selectProposedUsername = function () {
            modalScope.modalCtxt.isCustomUsernameSelected = false;
        };

        // Select Custom Employee Active Directory username
        modalScope.selectCustomUsername = function () {
            modalScope.modalCtxt.isCustomUsernameSelected = true;
        };

        // On Custom Employee Active Directory username Update
        modalScope.onCustomUsernameUpdate = function (username) {
            employeeService
                .checkCorrectWindowsAccount(username)
                .then(function (isCorrect) {
                    modalScope.modalCtxt.isCustomUsernameCorrect = isCorrect;
                });
        };

        // Ask For Employee Active Directory username
        modalScope.askForUsername = function () {
            return !modalScope.model.ActiveDirectoryAccountUsername;
        };

        // Is Confirm Matching Action Disabled?
        modalScope.isConfirmMatchingActionDisabled = function () {
            if ($scope.ctrlCtxt.isLoading) return true;
            if (_.isUndefined(modalScope.buToConfirmContainer)) return true;
            if (!_.isUndefined(modalScope.buToConfirmContainer.BusinessUnits) &&
              modalScope.buToConfirmContainer.BusinessUnits.length > 1 &&
              _.isUndefined(modalScope.model.BusinessUnitID)) return true;
            if (!modalScope.askForUsername()) return false;
            if (!modalScope.modalCtxt.isCustomUsernameSelected) return false;
            if (!modalScope.modalCtxt.isCustomUsernameCorrect) return true;

            return !modalScope.modalCtxt.customUsername || !modalScope.modalCtxt.isCustomUsernameCorrect.CanBeUsedForNewEmployee;
        };

        // Confirm Matching
        modalScope.confirmMatching = function () {

            $scope.ctrlCtxt.isLoading = true;
            employeeSyncService
                .getLatestBatch()
                .then(function (latestBatch) {

                    // Set Employee Active Directory username
                    var username;
                    if (!modalScope.askForUsername()) {
                        username = modalScope.model.ActiveDirectoryAccountUsername;
                    } else {
                        username = modalScope.modalCtxt.proposedAccount.ActiveDirectoryAccountUsername;
                        if (modalScope.modalCtxt.isCustomUsernameSelected) username = modalScope.modalCtxt.customUsername;
                    }

                    if (!_.isUndefined($scope.boxContext) && !_.isUndefined($scope.boxContext.latestClosedBatch)) {
                        modalScope.isLatestBatchDifferent = latestBatch.PubEmp_BatchID !== $scope.boxContext.latestClosedBatch.PubEmp_BatchID;
                    }

                    if (!modalScope.isLatestBatchDifferent) {

                        if (!_.isUndefined($scope.buToConfirmContainer.BusinessUnits) &&
                            $scope.buToConfirmContainer.BusinessUnits.length === 1) {
                            $scope.model.BusinessUnitID = $scope.buToConfirmContainer.BusinessUnits[0].BusinessUnitID;
                        }

                        return employeeSyncService
                            .confirmMatchingWithUsername($scope.model, username)
                                .then(function () {
                                    return $scope
                                            .refreshMatchingsAndExceptions()
                                            .then(function () {
                                                modalScope.hideModal();
                                            });
                                });
                    }
                })
                .finally(function () {
                    $scope.ctrlCtxt.isLoading = false;
                });
        };
    };

}]);
